const state = {
  // 当前定位
  geo: {
    lat: 0,
    lng: 0,
    hasError: false,
  },
  // 手动切换商圈后，不随geo更改
  manualChangedAreaGroup: false,
  areaGroup: {
    // 大区，城市，片区，商圈  {id:'', label: ''}
    region: {},
    city: {},
    district: {},
    area: {},
  },
  countryConfig: [], // 国家、时区、语言配置项
  countryMapLangConf: {}, // key为国家，value为当前国家下可选择的语言
  areaSelections: [], // 前者的选项list {code,name,child:[]}
  // 登录信息
  login: {
    status: null,
    phone: '',
    token: '',
    userInfo: { feature_auth: {} },
  },
  // 概况
  // summary: {},
  tagIds: [],
  taskIndex: [],
  serviceCity: [],
  vajraListData: [],
  onboardingIndex: {},
  engagementIndex: {},
  taskIndexList: [],
  // 列表筛选框计数
  countByStatus: {},
  global: {
    loading: 0,
    jumpPath: {},
    message: {},
  },
  shopCommonConfig: '',
  // 路由访问路径的数组集合，每次返回首页后 会清空数组
  routerQueue: [],
  // 是否对首页门店列表进行重新请求
  isRefreshHomeList: true,
  isRefreshHomeListAll: true,
  isRefreshHomeListPriority: true,
  // 是否对任务列表进行重新请求
  isRefreshTaskList: true,
  inWhiteList: undefined,
}

export default state
